export default function conditionalCounters<
  Node,
  CountersFns extends Record<string, (node: Node) => boolean>,
  CountersValues extends Record<keyof CountersFns, number>,
>(nodes: Node[], counterFns: CountersFns) {
  const countersValues = nodes.reduce<Record<string, number>>((counters, node) => {
    const nextCounters: Record<string, any> = counters;

    Object.keys(counterFns).forEach((key) => {
      const shouldCount = counterFns[key as keyof CountersFns];
      const currentValue = counters[key] || 0;
      if (shouldCount(node)) {
        nextCounters[key] = currentValue + 1;
      } else {
        nextCounters[key] = currentValue;
      }
    });

    return nextCounters;
  }, {});

  return countersValues as CountersValues;
}
